const PROTOCOL_PATTERN = /^((http|https|ftp):\/\/)/;

export const validateUrl = (url: string): string => {
    const cleanUrl = url.trim();

    // check if starts with http then just return it
    if (PROTOCOL_PATTERN.test(cleanUrl) || cleanUrl.startsWith('#') || cleanUrl.startsWith('mailto:')) {
        return cleanUrl;
    }

    const linkUrl = cleanUrl.startsWith('/') ? cleanUrl : `/${cleanUrl}`;
    return linkUrl;
};

export const removeProtocol = (url: string): string => {
    const cleanUrl = url.trim();

    return cleanUrl.replace(PROTOCOL_PATTERN, '');
};

export const getUrlOrigin = (urlString: string): string => {
    try {
        const url = new URL(urlString);
        return url.origin;
    } catch (error) {
        return '';
    }
};

export default validateUrl;
